class MethodOfCollectionService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/biobank/method-of-collections';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ methodOfCollection }) {
    const { data } = await this.axios.post(this.url, methodOfCollection);
    return data;
  }

  async update({ methodOfCollection }) {
    const { data } = await this.axios.put(this.url, methodOfCollection);
    return data;
  }

  async archive({ methodOfCollection }) {
    const { _id: id } = methodOfCollection;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: methodOfCollection });
    return data;
  }
}

export default MethodOfCollectionService;
